export enum QuoteStatus {
  Open = "Open",
  Emailed = "Emailed",
  Templete = "Templete",
  Accepted = "Accepted",
  All = "All",
}

export enum QuotesStatus {
  New = 1,
  EMailed = 2,
  Accepted = 3,
  Rejected = 4,
  Cancelled = 5,
  Converted = 6,
}
